import { render, staticRenderFns } from "./ChangeHuashuTypeDialog.vue?vue&type=template&id=70b6669b&scoped=true"
import script from "./ChangeHuashuTypeDialog.vue?vue&type=script&lang=js"
export * from "./ChangeHuashuTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeHuashuTypeDialog.vue?vue&type=style&index=0&id=70b6669b&prod&lang=css"
import style1 from "./ChangeHuashuTypeDialog.vue?vue&type=style&index=1&id=70b6669b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6669b",
  null
  
)

export default component.exports